<template>
  <el-row type="flex" justify="center">
    <el-col :md="18" :lg="14">
      <el-image :src="require('@/assets/images/zp.jpg')"></el-image>
      <el-row type="flex" class="content" justify="center">
        <el-col :xs="10" :sm="8" :xl="4">
          <!-- 招聘信息 -->
          <div class="jobkid">
            <div class="title flex-default">
              <div class="icon"></div>
              招聘信息
            </div>
            <ul class="leftKids">
              <li
                v-for="(item, index) in leftKid"
                :key="item.id"
                :class="{ active: index == activeIndex }"
                @click="changeItem(item, index)"
              >
                {{ item.name }}
              </li>
            </ul>

            <div class="title title1">
              <p>招聘邮箱：hxw@017vr.com</p>
              <p class="mt5">联系人：</p>
              <p>黄兴旺（市场、产品、策划类）</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="14" :sm="16">
          <div class="right">
            <div class="title">
              <ul class="flex-default">
                <li>职位名称</li>
                <li>职位类别</li>
                <li>用人部门</li>
                <li>招聘人数</li>
              </ul>
            </div>
            <div class="occupation">
                <ul class="tpl" v-for="item in jobList" :key="item.id">
                  <li>{{ item.name }}</li>
                  <li>{{ item.jobCategory }}</li>
                  <li>{{ item.employing }}</li>
                  <li>{{ item.jobNum }}</li>
                </ul>
                <ul v-if="jobList==0">
                  <li>暂无</li>
                </ul>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  methods: {
    changeItem(obj, index) {
      this.activeIndex = index;
      this.jobList = this.allList.filter((item) => {
        if (obj.kid == -1) {
          return true;
        }
        return item.kid == obj.kid;
      });
    },
  },
  created() {
    this.jobList = this.allList;
    this.activeIndex = 0;
  },
  data() {
    return {
      activeIndex: 0,
      jobList: [],
      leftKid: [
        {
          id: 0,
          name: "全部",
          kid: -1,
        },
        {
          id: 1,
          name: "程序",
          kid: 0,
        },
        {
          id: 2,
          kid: 1,
          name: "美术",
        },
        {
          id: 3,
          name: "市场",
        },
        {
          id: 4,
          name: "运营",
          kid: 3,
        },
        {
          id: 5,
          name: "商务",
          kid: 4,
        },
      ],
      // 0 程序 1 美术 2策划 3运营 4商务
      allList: [
        {
          id: 0,
          kid: 2,
          name: "数值策划",
          jobCategory: "策划",
          employing: "策划",
          jobNum: 1,
        },
        {
          id: 1,
          kid: 1,
          name: "UI主管",
          jobCategory: "美术",
          employing: "研发",
          jobNum: 1,
        },
        {
          id: 2,
          kid: 2,
          name: "关卡策划",
          jobCategory: "策划",
          employing: "研发",
          jobNum: 1,
        },
        {
          id: 3,
          kid: 0,
          name: "虚幻开发工程师",
          jobCategory: "程序",
          employing: "研发",
          jobNum: 2,
        },
        {
          id: 4,
          kid: 3,
          name: "运营",
          jobCategory: "运营",
          employing: "市场",
          jobNum: 1,
        },
        {
          id: 5,
          kid: 0,
          name: "前端工程师",
          jobCategory: "程序",
          employing: "研发",
          jobNum: 1,
        },
        {
          id: 6,
          kid: 0,
          name: "后端工程师",
          jobCategory: "程序",
          employing: "研发",
          jobNum: 1,
        },
        {
          id: 7,
          kid: 0,
          name: "C++开发工程师",
          jobCategory: "程序",
          employing: "研发",
          jobNum: 2,
        },
      ],
    };
  },
};
</script>

<style scoped lang='less'>
ul{//火狐padding
  padding: 0;
  margin: 0;
}
.flex-default {
  display: flex;
  align-items: center;
}
li {
  list-style: none;
}
.content {
  // border: 1px solid #000;
  margin-top: 5px;
  .el-col {
    // border: 1px solid #000;
    .jobkid {
      margin: 0 auto;
      // border: 1px solid red;
      width: 90%;
      .title {
        width: 99.5%;
        padding: 10px;
        box-sizing: border-box;
        color: #797979;
        border: 1px solid #e1e3e5;
        border-bottom: none;
        background-color: #fafafa;
        .icon {
          height: 30px;
          margin-right: 10px;
          width: 30px;
          background-image: url("../assets/images/书籍.png");
          background-size: 100%;
        }
      }

      .leftKids {
        display: flex;
        flex-wrap: wrap;
        // border: 1px solid #e1e3e5;
        li {
          margin: 0 -1px -1px 0;
          cursor: pointer;
          text-align: center;
          line-height: 100px;
          width: 50%;
          box-sizing: border-box;
          height: 100px;
          border: 1px solid #e1e3e5;
          color: #888;
          list-style: none;
          background-color: #fff;
          &:hover {
            background-color: #f5f5f5;
          }
          &.active {
            background-color: #f5f5f5;
             color: #eb4b27;
          }
        }
      }

      .title.title1 {
        margin-top: 10px;
        border: 1px solid #e1e3e5;
        font-size: 14px;
        p.mt5 {
          margin-top: 5px;
        }
      }
    }
    .right {
      margin: 0 auto;
      width: 90%;
      height: 80%;
      .title {
        background-color: #2a4362;
        color: #ccc;
        ul {
          justify-content: space-around;
          height: 40px;
          li {
            flex: 1;
            line-height: 40px;
            height: 100%;
            text-align: center;
            /* border-right: 1px solid red; */
            position: relative;
            &::after {
              content: "";
              position: absolute;
              right: 0;
              top: calc(50% - 10px);
              height: 20px;
              width: 2px;
              background-color: #fff;
            }
            &:last-child::after {
              width: 0;
              height: 0;
            }
          }
        }
      }

      .occupation {
        ul {
          cursor: pointer;
          color: #666;
          display: flex;
          justify-content: space-around;
          align-items: center;
          height: 40px;
          border: 1px solid #ccc;
          border-bottom: 1px solid transparent;
          &:last-child {
            border-bottom: 1px solid #ccc;
          }
          &:hover {
            background-color: #eee;
            color: #eb4b27;
          }
          li {
            text-align: center;
            flex: 1;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .jobkid {
    width: 80% !important;
  }
  .right {
    width: 100% !important;
    li {
      font-size: 14px;
    }
  }
}

@media screen and(max-width: 576px) {
  .jobkid {
    width: 100% !important;
    li {
      height: 70px !important;
      line-height: 70px !important;
    }
    .title1{
      margin-top: 0!important;
      p{
        margin-top: 0!important;
      }
    }
  }
  .right {
    width: 100% !important;
    li {
      font-size: 12px;
      &::after {
        width: 0 !important;
      }
    }
  }
}
</style>
